import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  @media screen and (max-width: 550px) {
    flex-direction: column;
  }
`;

export const Header = styled.div`
  text-align: center;

  @media screen and (max-width: 550px) {
    display: none;
  }
`;

export const MobileHeader = styled.div`
  display: none;
  margin-bottom: 16px;

  @media screen and (max-width: 550px) {
    display: block;
  }
`;

export const Actions = styled.div`
  margin-top: 8px;

  @media screen and (max-width: 550px) {
    display: none;
  }
`;

export const MobileActions = styled.div`
  margin-top: 16px;
  display: none;

  @media screen and (max-width: 550px) {
    display: block;
    width: 100%;
  }
`;

const BaseSection = styled.div`
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
`;

export const Section = styled(BaseSection)`
  background-color: #ffffff;
`;

export const ErrorSection = styled(BaseSection)`
  background-color: #f7eaec;
`;

export const StyledAnchor = styled.a`
  color: rgb(181, 50, 75);
  text-decoration: underline;
`;
